<template>
  <b-navbar variant="white" class="main-navbar border-bottom" sticky>
    <b-button
      class="d-lg-none mr-1"
      variant="outline-dark"
      @click="showMobileSidebar = true"
    >
      <font-awesome-icon :icon="['fas', 'bars']" />
    </b-button>
    <b-sidebar
      v-model="showMobileSidebar"
      sidebar-class="border-right"
      no-header
      backdrop
    >
      <SideMenu
        :collapsed="false"
        @toggle-collapsed="showMobileSidebar = false"
      />
    </b-sidebar>

    <b-navbar-brand :to="{ name: 'home' }" class="m-2">
      <h1 class="text-pmat-gray m-0">
        <WinkingLogo class="main-logo d-none d-sm-inline" />
        Interné
      </h1>
    </b-navbar-brand>

    <b-navbar-nav class="ml-auto">
      <template v-if="$root.isAuthenticated">
        <b-button
          key="navbar-profile-button"
          :to="{ name: 'profile-detail' }"
          variant="outline-dark"
          class="m-1"
        >
          <font-awesome-icon :icon="['fas', 'user-circle']" />
          <span class="d-none d-md-inline">
            {{ $root.state.user === null ? "" : $root.state.user.full_name }}
          </span>
        </b-button>
        <b-button
          key="navbar-logout-button"
          variant="outline-dark"
          class="m-1"
          @click="logout"
        >
          <font-awesome-icon :icon="['fas', 'sign-out-alt']" />
          <span class="d-none d-md-inline"> Odhlásiť sa </span>
        </b-button>
      </template>
      <b-button
        v-else
        key="navbar-login-button"
        v-b-modal.login-modal
        variant="outline-dark"
        class="m-1"
      >
        <font-awesome-icon :icon="['fas', 'sign-in-alt']" />
        <span class="d-none d-md-inline"> Prihlásiť sa </span>
      </b-button>

      <b-button
        v-for="seminary in constants.allSeminary"
        :key="seminary.title"
        :href="seminary.url"
        :variant="seminary.variant"
        class="m-1 d-none d-lg-block"
      >
        {{ seminary.title }}
      </b-button>
    </b-navbar-nav>
  </b-navbar>
</template>

<script>
import { SideMenu } from "frontend-common";
import constants from "@/constants";
import WinkingLogo from "@/easter-eggs/WinkingLogo.vue";

export default {
  name: "MainNavbar",
  components: {
    SideMenu,
    WinkingLogo,
  },
  mixins: [],
  props: {},
  data() {
    return {
      constants,
      showMobileSidebar: false,
    };
  },
  mounted() {},
  methods: {
    logout() {
      this.$root.unsetAuthToken();
      this.$root.successToast("Odhlásenie úspešné!");
    },
  },
};
</script>

<style scoped>
.main-logo {
  height: 1.1em;
  margin-top: -0.25em;
}

.other-logo {
  height: 1em;
  margin-top: -2px; /* bad vertical centering of the svg inside button link */
}
</style>
